import { render, staticRenderFns } from "./diamondDetails.vue?vue&type=template&id=296d7522&scoped=true"
import script from "./diamondDetails.vue?vue&type=script&lang=js"
export * from "./diamondDetails.vue?vue&type=script&lang=js"
import style0 from "./diamondDetails.vue?vue&type=style&index=0&id=296d7522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296d7522",
  null
  
)

export default component.exports